import { render, staticRenderFns } from "./Votes.vue?vue&type=template&id=2dcd8546&scoped=true"
import script from "./Votes.vue?vue&type=script&lang=js"
export * from "./Votes.vue?vue&type=script&lang=js"
import style0 from "./Votes.vue?vue&type=style&index=0&id=2dcd8546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd8546",
  null
  
)

export default component.exports